import { makeAutoObservable, runInAction } from 'mobx';
import get from 'lodash/get';
import { t } from 'react-switch-lang';
import { toast } from 'react-toastify';
import { sendFirebaseToken } from '../../auth/authApi';
import { requestGet, requestPost } from '../../services/real.backend';
import {
  API_AUTH_LOGIN_PASS,
  API_CHANGE_PASSWORD,
  API_SEND_PASSWORD_LINK,
  API_USER_UPLOAD_AVATAR, API_USERS_UPDATE,
} from '../../services/apiPoints';
import dictionaries from './dictionaries';
import UserModel from '../../models/UserModel';
import ProfileModel from '../../models/ProfileModel';

class AuthStorage {
    isLogged = false;

    id = 0;

    login = '';

    email = '';

    name = '';

    soname = '';

    surname = '';

    emailVerified = false;

    avatar = '';

    status = 0;

    staffName = '';

    authError = false;

    authErrorMessage = '';

    originalUser = '';

    enteredLogin = '';

    enteredPassword = '';

    onlineStatus = 1;

    group_id = 0;

  profileImageUploadDialogOpened = false;

  changedFields = {};

  roles = {};

  permissions = {};

  perfectum_id = '0';

  get haveChanges() {
    return Object.keys(this.changedFields).length > 0;
  }

    authStateChanged = (user) => {
      if (user) {
        user
          .getIdToken()
          .then((idToken) => {
            sendFirebaseToken(idToken)
              .then((resp) => {
                if (resp && resp.profile && resp.profile != -1) {
                  runInAction(() => {
                    this.setCredientials(resp.profile);
                  });
                }
              });
          });
      } else {
        // this.clearCredientals();
      }
    }

    clearCredientals = () => {
      this.isLogged = false;
      this.id = 0;
      this.login = '';
      this.soname = '';
      this.email = '';
      this.emailVerified = false;
      this.avatar = null;
      this.status = 0;

      this.authError = false;
      this.authErrorMessage = '';
      this.originalUser = '';
      this.enteredLogin = '';
      this.enteredPassword = '';
      this.perfectum_id = '';
    };

  profileImageUploadDialogToggle = () => this.profileImageUploadDialogOpened = !this.profileImageUploadDialogOpened;

  saveProfile = () => {
    if (Object.keys(this.changedFields).length == 0) return;
    const profile = new ProfileModel();
    profile.id = this.id;
    profile.fromObject(this);
    requestPost(API_USERS_UPDATE, {
      users: {
        [this.id]: profile.onlyList(Object.keys(this.changedFields).concat(['id'])),
      },
    })
      .then((resp) => {
        this.changedFields = {};
      })
      .catch((e) => {
        console.log(e);
      });
  };

  sendRestoreLink = () => {
    requestGet(API_SEND_PASSWORD_LINK.replace('{id}', this.id))
      .then((resp) => {
        toast.success(t('auth.Password change link sent'));
      });
  };

  getProfileImageUploadParams = ({ meta }, ...rest) => ({ url: API_USER_UPLOAD_AVATAR.replace('{uid}', this.id) });

  handleProfileImageUpload = (req, status, resp) => {
    if (status === 'done') {
      const response = JSON.parse(resp[0].xhr.response);
      if (response && response.users) {
        const profile = response.users[0];
        this.avatar = profile.avatar;
      }
    }
  };

  constructor() {
    makeAutoObservable(this);
  }

  itemHasRole = (roles) => roles.reduce((acc, role) => (this.roles[role] ? true : acc), false)

    changeField = (field, value) => {
      this[field] = value;
      this.changedFields[field] = true;
    }

    loginWithEmailAndPassword = (onSuccess = null) => {
      requestPost(API_AUTH_LOGIN_PASS, {
        login: this.enteredLogin, password: this.enteredPassword,
      }).then((resp) => {
        if (resp.profile && resp.profile != -1) {
          // Нормально пользователь получен
          runInAction(() => {
            this.setCredientials(resp.profile);
            dictionaries.loadDictionaries();
            if (onSuccess) {
              onSuccess();
            }
          });
        } else {
          toast.error(t('auth.Incorrect credientials'));
        }
      });
      // authStorage.setCredientials
    }

    setCredientials = (profile) => {
      this.isLogged = true;
      this.id = profile.id;
      this.name = profile.name;
      this.login = profile.login;
      this.soname = profile.soname;
      this.surname = profile.surname;
      this.email = profile.email;
      this.emailVerified = profile.emailVerified;
      this.avatar = profile.avatar;
      this.status = profile.status;
      this.group_id = profile.group_id;
      this.authError = false;
      this.authErrorMessage = '';
      this.perfectum_id = profile.perfectum_id;
      this.roles = {};
      if (profile.roles) profile.roles.map((role) => this.roles[role] = true);
      this.permissions = {};
      if (profile.permissions) profile.permissions.map((permission) => this.permissions[permission] = true);
    }

    processError = (error) => {
      this.authError = error.code;
      this.authErrorMessage = error.message;
    }

  resetPassword = (id) => {
    requestGet(
      API_SEND_PASSWORD_LINK.replace('{id}', id),
    ).then((r) => {
      toast.info(t('auth.Password change link sent'));
    });
  }
}

const authStorage = new AuthStorage();

export default authStorage;
